import * as React from 'react';
import { DatePicker } from '@liveauctioneers/hammer-ui-core/datePicker';
import { parseISO } from 'date-fns';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import Facet from './Facet';
import isEqual from 'react-fast-compare';

type Props = {
    onDateChange: Function;
    selectedDate: string;
};

const DatePickerFacet = ({ onDateChange, selectedDate }: Props) => {
    const { formatMessage } = useIntl();
    const date = selectedDate !== '' ? parseISO(selectedDate) : undefined;

    return (
        <Facet
            className="date-picker-facet auction-date"
            closeFacet={false}
            title={formatMessage({ id: 'auction_date' })}
        >
            <DatePicker
                closeOnSelect
                date={date}
                onClear={() => {
                    onDateChange('');
                }}
                onValidDateChange={(dateChanged) => {
                    onDateChange(dateChanged);
                }}
                placeholder={formatMessage({ id: 'select_date_placeholder' })}
                showClearIcon
            />
        </Facet>
    );
};

export default React.memo<Props>(DatePickerFacet, isEqual);
